// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Results Page Styles */
.results-page {
  --results-type-heading: clamp(2.2rem, 3.2vw, 3.3rem);
  --results-type-body: 1.2rem;
  min-height: 100vh;
  padding: 6rem 0 4rem;
}

.page-hero {
  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);
  color: white;
  padding: 6rem 0 4rem;
  text-align: center;
}

.hero-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 2rem;
}

.page-title {
  font-size: var(--results-type-heading);
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 1rem;
}

.page-subtitle {
  font-size: var(--results-type-body);
  line-height: 1.6;
  opacity: 0.9;
  max-width: 600px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .page-hero {
    padding: 4rem 0 3rem;
  }
  
  .page-title {
    font-size: 2rem;
  }
  
  .page-subtitle {
    font-size: 1.125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/frontend/pages/Results/results.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,0EAA0E;EAC1E,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":["/* Results Page Styles */\r\n.results-page {\r\n  --results-type-heading: clamp(2.2rem, 3.2vw, 3.3rem);\r\n  --results-type-body: 1.2rem;\r\n  min-height: 100vh;\r\n  padding: 6rem 0 4rem;\r\n}\r\n\r\n.page-hero {\r\n  background: linear-gradient(135deg, var(--color-primary) 0%, #4a1548 100%);\r\n  color: white;\r\n  padding: 6rem 0 4rem;\r\n  text-align: center;\r\n}\r\n\r\n.hero-container {\r\n  max-width: 1280px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n}\r\n\r\n.page-title {\r\n  font-size: var(--results-type-heading);\r\n  font-weight: 800;\r\n  line-height: 1.2;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.page-subtitle {\r\n  font-size: var(--results-type-body);\r\n  line-height: 1.6;\r\n  opacity: 0.9;\r\n  max-width: 600px;\r\n  margin: 0 auto;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .page-hero {\r\n    padding: 4rem 0 3rem;\r\n  }\r\n  \r\n  .page-title {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .page-subtitle {\r\n    font-size: 1.125rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
